import {
  Configuration,
  type ConfigurationParameters,
  ReachApi
} from './hau-itde-reach-portal-api/';

//set base path of api
const configParams: ConfigurationParameters = {
  basePath: import.meta.env.VITE_PORTAL_API_BASE_URL
};
const config = new Configuration(configParams);

/**
 * Use this export for api access
 * @exports ReachApi callable configured reach api
 */
export const reachApi = new ReachApi(config);
